import api from './api';

const orderService = {
  // Create order
  create: async (orderData) => {
    const response = await api.post('/orders', orderData);
    return response.data;
  },

  // Get all orders (role-based)
  getAll: async (params = {}) => {
    const response = await api.get('/orders', { params });
    return response.data;
  },

  // Get order by ID
  getById: async (id) => {
    const response = await api.get(`/orders/${id}`);
    return response.data;
  },

  // Confirm order (seller/admin)
  confirm: async (id, sellerNote) => {
    const response = await api.put(`/orders/${id}/confirm`, { seller_note: sellerNote });
    return response.data;
  },

  // Update order items (seller/admin)
  update: async (id, items, sellerNote) => {
    const response = await api.put(`/orders/${id}/update`, {
      items,
      seller_note: sellerNote,
    });
    return response.data;
  },

  // Cancel order
  cancel: async (id, reason) => {
    const response = await api.put(`/orders/${id}/cancel`, { reason });
    return response.data;
  },

  // Update order status (seller/admin)
  updateStatus: async (id, status) => {
    const response = await api.put(`/orders/${id}/status`, { status });
    return response.data;
  },
};

export default orderService;
